import React from 'react';
import useTranslation from '~/app/hooks/useTranslation';
import MForm from '~/app/modules/form';
import Textarea from '~/app/modules/form/Textarea';
import useForm from '~/app/modules/form/useForm';
import { TrainingApprovalPayload } from '~/training/types';
import classes from './style.module.scss';

export type DetailsComponent = React.FC;

const Details: DetailsComponent = () => {
  const { t } = useTranslation('training');
  const { values: formValues, fieldEvents: formFieldEvents, errors } = useForm<TrainingApprovalPayload>({ formName: 'approveTraining' });

  return (
    <>
      <MForm className={`${classes['form']} ${classes['details']}`}>
        <div className={classes['training-approve']}>
          <Textarea
            className={`${classes['input-container']}`}
            placeholder={t('commentPlaceholder')}
            descriptionPosition="top"
            name="comment"
            defaultValue={formValues.comment.toString()}
            errors={errors.comment}
            {...formFieldEvents}
          />
        </div>
      </MForm>
    </>
  );
};

export default Details
